import { Typography, Box } from '@mui/material';
import { selectUser } from 'app/store/userSlice';
import axios from 'axios';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const SeriaDialog = ({ seria }) => {
    const user = useSelector(selectUser);
    const { t } = useTranslation('translate-language');
    const [branch, setBranch] = useState([]);
    const [data, setData] = useState([]);
    const [data2, setData2] = useState([]);

    useEffect(() => {
        axios.get(`v1/branch/get-all`).then(response => {
            const sortDataById = response?.data.sort((a, b) => a.id - b.id);
            setBranch(sortDataById);
        });

    }, []);

    useEffect(() => {

        if (seria) {
            axios.get(`v1/material-account/product-ref/get-by-pagination/condition/?sort=name&direction=asc&page=0&size=25&name=${seria}&brand_id=-1&category_id=-1&sub_category_id=-1&type_id=-1&branch_id=${user.branch_id}&is_exists=0`).then(response => {
                // const sortedData = response.data.sort((a, b) => new Date(b.oper_day) - new Date(a.oper_day));
                setData2(response.data);
            }).catch((error) => {
                setData2([])
            })

            axios
                .get(`/product-pieces/get-all-piece-ref?ref_number=${seria}&branch_id=0`)
                .then((response) => {
                    setData(response.data || []);
                })
                .catch(() => {
                    setData([]);
                });
        }
    }, [seria]);

    /**
     * 🔹 branch_id bo‘yicha group qilingan data
     */
    const groupedByBranch = useMemo(() => {
        return data.reduce((acc, item) => {
            if (!acc[item.branch_id]) {
                acc[item.branch_id] = [];
            }
            acc[item.branch_id].push(item);
            return acc;
        }, {});
    }, [data]);

    return (
        <Box className="w-full space-y-24">
            {Object.keys(groupedByBranch).length === 0 && (
                <Typography className="text-center text-[22px] text-gray-500">
                    {t('No data')}
                </Typography>
            )}

            {seria && <Box>

                <Typography className="text-[18px]">
                    {t('Nomi')}: <b>{data2?.content?.[0]?.name}</b>
                </Typography>

                <Typography className="text-[16px]">
                    {t('Ref id')}: <b>{data2?.content?.[0]?.ref_number}</b>
                </Typography>

                <Typography className="text-[16px]">
                    {t('Size')}: <b>{data2?.content?.[0]?.size}</b>
                </Typography>

                <Typography className="text-[16px]">
                    {t('Amount')} : <b>{data2?.content?.[0]?.amount} $</b>
                </Typography>

                <Typography className="text-[16px]">
                    {t('Amount')} : <b>{data2?.content?.[0]?.amount * user.currency_amount} {t("Sum")}</b>
                </Typography>

                <Typography className="text-[16px]">
                    {t('Total')}: <b>{data2?.content?.[0]?.count}</b>
                </Typography>

            </Box>}

            {Object.entries(groupedByBranch).map(([branchId, items]) => (
                <Box
                    key={branchId}
                    className="p-16 rounded-12 bg-gray-100 border border-gray-200"
                >
                    {/* 🔹 Branch title */}
                    <Typography className="text-lg font-bold text-blue-700 mb-16">
                        {t("Branch")}: {branch.find(a => a.id == branchId)?.name}
                    </Typography>

                    {/* 🔹 Branch items */}
                    <Box className="space-y-12">
                        {items.map((row) => (
                            <Box
                                key={row.id}
                                className="p-12 rounded-8 bg-white shadow-sm border border-gray-100"
                            >


                                <Typography className="text-[18px]">
                                    {t('Quantity')}: <b>{row.quantity}</b>
                                </Typography>

                                <Typography className="text-[18px]">
                                    {t('Rulon')}: <b>{row.count}</b>
                                </Typography>

                                {/* <Typography className="text-xs text-gray-400">
                                    State ID: {row.state_id}
                                </Typography> */}
                            </Box>
                        ))}
                    </Box>
                </Box>
            ))}
        </Box>
    );
};

export default SeriaDialog;
